import _sfc_main from "./index74.js";
/* empty css        */
import _export_sfc from "./index63.js";
const TableFace = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-0837663e"]]);
export {
  TableFace as default
};
//# sourceMappingURL=index16.js.map
